import { useCallback, useMemo, useState } from 'react'

import { UserPoolSidePanelActionsContext, UserPoolSidePanelStateContext } from './context'

const defaultUserPoolSidePanelProps = { isOpen: false }

export const UserPoolSidePanelProvider = ({ children }) => {
  const [userPoolSidePanelProps, setUserPoolSidePanelProps] = useState(defaultUserPoolSidePanelProps)

  const openUserPoolSidePanel = useCallback(({ userPoolUid, targetRef, minHeight }) => {
    setUserPoolSidePanelProps({ isOpen: true, userPoolUid, targetRef, minHeight })
  }, [])

  const closeUserPoolSidePanel = useCallback(() => {
    setUserPoolSidePanelProps(defaultUserPoolSidePanelProps)
  }, [])

  const state = useMemo(() => ({
    ...userPoolSidePanelProps
  }), [userPoolSidePanelProps])

  const actions = useMemo(() => ({
    openUserPoolSidePanel, closeUserPoolSidePanel
  }), [openUserPoolSidePanel, closeUserPoolSidePanel])

  return (
    <UserPoolSidePanelStateContext.Provider value={state}>
      <UserPoolSidePanelActionsContext.Provider value={actions}>
        {children}
      </UserPoolSidePanelActionsContext.Provider>
    </UserPoolSidePanelStateContext.Provider>
  )
}
